import * as React from 'react';

export const caFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_485)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_485'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_485)'>
                <path
                    d='M14.2745 15.4902H13.7255L13.8627 13.2941C13.855 13.1785 13.7995 13.1481 13.5882 13.1569L11.3922 13.4314C11.3922 13.4314 11.8039 12.8824 11.8039 12.6079C11.8039 12.3333 9.33333 10.549 9.33333 10.549C9.33333 10.549 9.88235 10.4118 10.0196 10.2745C10.1569 10.1373 9.47058 8.62746 9.47058 8.62746C9.47058 8.62746 10.8654 9.17648 10.9804 9.03923C11.0954 8.90197 11.2549 8.35295 11.2549 8.35295C11.2549 8.35295 12.3529 9.58825 12.6274 9.58825C12.902 9.58825 12.0784 6.56864 12.0784 6.56864C12.0784 6.56864 12.7647 7.11766 13.0392 7.11766C13.3137 7.11766 14 5.33334 14 5.33334C14 5.33334 14.6863 7.11766 14.8235 7.11766C14.9608 7.11766 15.9216 6.56864 15.9216 6.56864C15.9216 6.56864 15.2353 9.45099 15.3725 9.58825C15.5098 9.7255 16.7451 8.35295 16.7451 8.35295C16.7451 8.35295 16.8823 8.90197 17.0196 9.03923C17.1569 9.17648 18.5294 8.62746 18.5294 8.62746C18.5294 8.62746 17.8431 10.1373 17.9804 10.2745C18.1176 10.4118 18.6667 10.549 18.6667 10.549C18.6667 10.549 16.1961 12.3333 16.1961 12.6079C16.1961 12.8824 16.4706 13.4314 16.4706 13.4314L14.4118 13.1569C14.2463 13.1094 14.1889 13.1454 14.1372 13.2941L14.2745 15.4902Z'
                    fill='#D52B1E'
                />
                <rect
                    x='21.3333'
                    width='6.66667'
                    height='20'
                    fill='#D52B1E'
                />
                <rect
                    width='6.66667'
                    height='20'
                    fill='#D52B1E'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_485'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
